module.exports = __webpack_public_path__ + "static/media/noTemplates.4c702b39.svg";